enum SwipeGesture {
  SwipeUp,
  SwipeDown,
  SwipeLeft,
  SwipeRight,
}

export default SwipeGesture;
